export enum CategoryType {
    PRODUCT = 1,
    SERVICE = 2,
  }
  